















import { Vue, Component, Prop } from 'vue-property-decorator';
import FieldSettingsContainer from '@/dealroom/fields/context-menu/components/FieldSettingsContainer.vue';
import FieldTextSizeItem from '@/dealroom/fields/context-menu/components/menu-components/FieldTextSizeItem.vue';
import { IField } from '@/dealroom/fields/types/field';
import { FieldHelper } from '@/dealroom/fields/helpers/field.helper';

@Component({
  components: {
    FieldSettingsContainer,
    FieldTextSizeItem,
  },
})
export default class FieldTextSize extends Vue {
  @Prop() textSizes!: number[];
  @Prop() field!: IField;
  @Prop() pageWidth: number;
  @Prop() height: string;

  isSelected(size: number): boolean {
    const selectedTextSize: number = FieldHelper.getTextSize(
      this.field.position,
      this.pageWidth,
      this.textSizes
    );
    return size === selectedTextSize;
  }

  handleSelect(size: number) {
    this.$emit('select', size);
  }
}
